export { default } from "./TeacherComponentLegacy";
